import classnames from 'classnames';
const { __ } = wp.i18n;
import renderSVG from "../../../util/RTCLGB-icon-controls/renderIcon"
function StyleGrid(props) {
	const {
		style,
		desc_limit,
		show_desc,
		show_count,
		show_logo,
		show_title,
		count_after_text,
		col_xl,
		col_lg,
		col_md,
		col_sm,
		col_mobile,

		data,
	} = props;

	const wrapperClass = classnames([
		'rtcl',
		'rtcl-gb-listing-store',
		'style-' + style
	])

	const colClasses = classnames([
		'rtcl-col-wrap',
		'col-xl-' + col_xl,
		'col-lg-' + col_lg,
		'col-md-' + col_md,
		'col-sm-' + col_sm,
		'col-xs-' + col_mobile,
	])

	return [
		data.length ? (

			<div className={wrapperClass}>
				<div className="row auto-clear">

					{data.map((store, index) => (

						<div key={index} className={colClasses}>
							<div className="rtcl-item">

								{(show_logo && store.logo) && (
									<div className="rtcl-logo">
										<a href={store.permalink} dangerouslySetInnerHTML={{ __html: store.logo }}></a>
									</div>
								)}

								{(show_title && store.title) && (
									<h3 className="rtcl-title">
										<a href={store.permalink}>{store.title}</a>
									</h3>
								)}

								{(show_count && store.count) && (
									<div className="rtcl-count">{!count_after_text ? store.count == 1 ? store.count + __(' Ad') : store.count + __(' Ads') : store.count + ' ' + count_after_text}</div>
								)}

								{(show_desc && store.description) && (
									<p className="rtcl-description">{`${store.description.split(' ', desc_limit).join(' ') + '....'}`}</p>
								)}

							</div>
						</div>

					))}

				</div>
			</div>


		) : ''
	]
}

export default StyleGrid;